// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Ljg7","info":"PatientInfo_info__1eD_E"};